// refactor_todo_maybe Bring up to date with new patterns

import tasksService from '../../services/tasksService.js';
import dataModel from '../../models/DataModel';
import ReduxConstants from '../../constants/ReduxConstants.js';
import { RecordStates } from '../../constants/ReduxConstants.js';
import AOCollection from './AOCollection.js';
import { resolve } from 'path';

export const task_summary_root = {
  task: {
    project: {},
    user_task_assignments: {
      user: { additionalFields: ['profile_image'], 
        companies: {},
      },
    },
  },
};
export default class TasksAssignedCollection extends AOCollection {

  constructor(userId, companyId, statusFilter, activeOnly, page, perPage, searchString, project_id, options,filter) {
    super({
      name: ReduxConstants.USER_ASSIGNED_TASKS,
      collectionType: ReduxConstants.TASK,
      page,
      perPage,
      searchString,
      userId,
      subKey: statusFilter + (activeOnly ? '_active' : '_all') + (project_id ? '_' + project_id : '_all'),
      companyId,
      filter,
    });
    this._statusFilter = statusFilter;
    this.activeOnly = activeOnly;
    this._project_id = project_id;
    if (!options){
      options = { recordDescriptor: task_summary_root };
    }
    this.options = options;
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }

  static build(userId, companyId, statusFilter, activeOnly, page, perPage, searchString, project_id, options, filter) {
    let collection = new TasksAssignedCollection(userId, companyId, statusFilter, activeOnly, page, perPage, searchString, project_id, filter);
    collection.page = 0;
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  set statusFilter(value) {
    this._statusFilter = value;
    this._recordState = RecordStates.NEEDS_SYNC;
    dataModel.collectionsDAO.setCollection(this.getKey(), this.getData(), this.getCollectionType());
  }

  get statusFilter() {
    if (this._statusFilter && this._statusFilter[0] == 'under_review') {
      return ['pending_review', 'pending_approval'];
    }
    else {
      return this._statusFilter;
    }
  }

  set project_id(projectId) {
    this._project_id = projectId;
  }

  getDefaultData() {
    return { name: this.getName(), subKey: this.subKey, statusFilter: this.statusFilter, activeOnly: false, page: this.page, perPage: this.perPage, searchString: this.searchString, ids: [], _recordState: '' };
  }

  async fetchNext(pageOverride, showArchived = null, options) {

    if (!options){
      options = this.options;
    }
    if (dataModel.isOffline) {
      return this.handleOfflineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else this.page++;

        let serviceCall = tasksService.getMyTasks.bind(this, this.statusFilter ? this.statusFilter.join(',') : null, this.activeOnly, dataModel.companiesDAO.currentCompany.id,
          this._project_id, this.page, this.perPage, showArchived, options, this._filter);
      
        let newCollection = await this._fetchData(serviceCall, options, true);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }
    
        newCollection.totalTasks = newCollection.meta ? newCollection.meta.total_tasks : 0;
        newCollection.totalPages = newCollection.meta ? newCollection.meta.total_pages : 0;

        return resolve(newCollection);
      });
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    if (dataModel.isOffline) {
      let newCollection = await this.handleOfflineFetch(options);
      newCollection.totalTasks = newCollection.ids ? newCollection.ids.length : 0;
      resolve(newCollection);
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();

        let page = null;
        let perPage = null;
        
        // Get everything we already got
        if (shouldPaginate) {
          if (!options) {
            options = {};
          }
          options.clear = true;
          this.page = 1;
          page = 1;
          if (collection && collection.perPage) {
            perPage = Math.max(this.perPage, collection.ids.length);
          }
        }
    
        let serviceCall = tasksService.getMyTasks.bind(this, this.statusFilter ? this.statusFilter.join(','): null, this.activeOnly, localStorage.current_company_id,
          this._project_id, page, perPage, false, options, this._filter);
      
        let newCollection = await this._fetchData(serviceCall, options);
        if (newCollection.offline) {
          newCollection = await this.handleOffLineFetch(options);
          newCollection.totalTasks = newCollection.ids ? newCollection.ids.length : 0;
          resolve(newCollection);
        }
        else {
          newCollection.totalTasks = newCollection.meta ? newCollection.meta.total_tasks : 0;
          newCollection.totalPages = newCollection.meta ? newCollection.meta.total_pages : 0;
        }
  
        resolve(newCollection);
      });
    }
  }

  handleOfflineFetch(options) {
    return new Promise((resolve) => {
      let collection = this.getDenormalizedCollection(options);
      if (collection) {
        collection.tasks = dataModel.tasksDAO.getOfflineFilteredTasks(this._project_id, this.statusFilter);
        collection.ids = collection.tasks.map(task => { return task.id; });
      }
      resolve(collection);
    });
  }

  reset() {
    const data = this.getDefaultData();
    this.page = 1;
    dataModel.collectionsDAO.setCollection(this.getKey(), data, this.getCollectionType());
  }

  async processItemActionCable(updatedTask, acData, recordDescriptor) {
    return new Promise((resolve) => {
      const tasksCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (acData.type == 'updateTaskAssignment') {
        if (updatedTask.user_task_assignments &&
          updatedTask.user_task_assignments.filter(user => { return user.user_id == dataModel.usersDAO.currentUser.id; }).length > 0) {
          
          // if the task doesn't exist, add it
          if (!tasksCollection.ids.find(id => { return id == updatedTask.id; })) {
            tasksCollection.tasks.push(updatedTask);
            tasksCollection.meta.total_tasks++;
          }
        }
        else if (tasksCollection.ids.find(id => { return id == updatedTask.id; })) {
          // remove the task
          let found = false;
          tasksCollection.tasks = tasksCollection.tasks.filter(proj => {
            if (proj.id != acData.task_id){
              return true;
            }
            else {
              found = true;
              return false;
            }
          });
          if (found) {
            tasksCollection.meta.total_tasks--;
          }
        }
        tasksCollection.totalRecords = tasksCollection.totalTasks = tasksCollection.meta.total_tasks;
        tasksCollection.ids = this.normalizeCollection(tasksCollection.tasks, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), tasksCollection, this.getCollectionType());
        return resolve(this.getDenormalizedCollection({ recordDescriptor }));
      }
      if (acData.type == 'updateTask') {
        if (updatedTask) {
          let found = false;
          
          tasksCollection.tasks = tasksCollection.tasks.map(proj => {
            if (proj.id == updatedTask.id) {
              found = true;
              return updatedTask;
            }
            else {
              return proj;
            }
          });
          if (!found) {
            let addTask = false;
            if (updatedTask.user_task_assignments &&
              updatedTask.user_task_assignments.filter(user => { return user.user_id == dataModel.usersDAO.currentUser.id; }).length > 0) {
              addTask = true;
            }
            else if (updatedTask.users &&
              updatedTask.users.filter(user => { return user.id == dataModel.usersDAO.currentUser.id; }).length > 0) {
              addTask = true;
            }
            if (addTask) {
              tasksCollection.tasks.push(updatedTask);
              tasksCollection.meta.total_tasks++;
              tasksCollection.totalRecords = tasksCollection.totalTasks = tasksCollection.meta.total_tasks;
            }
          }
          tasksCollection.ids = this.normalizeCollection(tasksCollection.tasks, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), tasksCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
      }
      else if (acData.type == 'deleteTask') {
        let found = false;
        tasksCollection.tasks = tasksCollection.tasks.filter(proj => {
          if (proj.id != acData.task_id){
            return true;
          }
          else {
            found = true;
            return false;
          }
        });
        if (found) {
          tasksCollection.meta.total_tasks--;
        }
        tasksCollection.totalRecords = tasksCollection.totalTasks = tasksCollection.meta.total_tasks;
        tasksCollection.ids = this.normalizeCollection(tasksCollection.tasks, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), tasksCollection, this.getCollectionType());
        return resolve(this.getDenormalizedCollection({ recordDescriptor }));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/dao/collections/TasksAssignedCollection.js